import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
});

export const registerApi = (payload) => api.post("/user/register", payload);
export const sendRegistrationOtpApi = (payload) => api.post("/user/send-registration-otp", payload);
export const getLoginTokenApi = (payload) => api.post("/user/get-login-token", payload);
export const getAllCountriesApi = () => api.get("/directories/business-master/country-directory/get-all");
export const getAllTradesApi = () => api.get("/directories/business-master/trade-of-work/get-all");
